export default {
  en: [
    { label: 'nrel', violation: 'Not Related to Language Learning' },
    { label: 'nudi', violation: 'Nudity' },
    { label: 'viol', violation: 'Violence' },
    { label: 'hara', violation: 'Harassment' },
    { label: 'hasp', violation: 'Hate Speech' },
    { label: 'spam', violation: 'Spam' },
    { label: 'smth', violation: 'Something Else' },
  ],
  it: [
    { label: 'nrel', violation: "Non Correlato all'Apprendimento delle Lingue" },
    { label: 'nudi', violation: 'Nudità' },
    { label: 'viol', violation: 'Violenza' },
    { label: 'hara', violation: 'Molestia' },
    { label: 'hasp', violation: "Incitamento all'Odio" },
    { label: 'spam', violation: 'Spam' },
    { label: 'smth', violation: "Qualcos'altro" },
  ],
};
